module.exports = __webpack_public_path__ + "static/media/icono_cereal_.43d2835f.png";